import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";
import type * as React from "react";
import { cn } from "./cn";

// The mock's .chip: a 24 px pill; tones from the status tokens.
const badgeVariants = cva(
  "inline-flex h-6 w-fit shrink-0 items-center gap-1.5 rounded-full px-2.5 text-xs font-semibold whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3.5",
  {
    variants: {
      variant: {
        default: "bg-neutral-soft text-ink-2",
        primary: "bg-primary-soft text-ink",
        ok: "bg-ok-soft text-ok-ink",
        warn: "bg-warn-soft text-warn-ink",
        crit: "bg-crit-soft text-crit-ink",
        info: "bg-info-soft text-info-ink",
        outline: "border border-line-strong text-ink-2",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

function Badge({
  className,
  variant = "default",
  asChild = false,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span";
  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
